import { createSelector } from '@reduxjs/toolkit';
import selectAccounts from './selectAccounts';
import selectCurrentAccountId from './selectCurrentAccountId';

export default createSelector(selectAccounts, selectCurrentAccountId, (accounts, accountId) =>
  accounts.find(({ id }) => id === accountId)
);
